import { render, staticRenderFns } from "./vipBirthdayActivity.vue?vue&type=template&id=76c13734&scoped=true"
import script from "./vipBirthdayActivity.vue?vue&type=script&lang=js"
export * from "./vipBirthdayActivity.vue?vue&type=script&lang=js"
import style0 from "./vipBirthdayActivity.vue?vue&type=style&index=0&id=76c13734&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c13734",
  null
  
)

export default component.exports